import { Plus } from "lucide-react";
import ButtonV2 from "../../../../components/ui/button/v2";
import { InterviewWithState } from "../../logic/InterviewAnalysisSlice";
import { AutoSelectVerticalNav } from "../../../../components/ui/navigation/AutoSelectVerticalNav";

interface InterviewListProps {
    interviews: InterviewWithState[];
    selectedInterviewId: string | null;
    onAddInterview: () => void;
    onSelectInterview?: (interviewId: string) => void;
}

// TODO:: Add Employee Name field once backend supports it (line:28)
const InterviewList: React.FC<InterviewListProps> = ({ interviews, onAddInterview, onSelectInterview, selectedInterviewId }) => {
    const hasTemporaryInterview = interviews.some(interview => interview.id.startsWith('temp-'));
    
    return (
        <div className="bg-slate-100 rounded-md p-2 h-full">
            <AutoSelectVerticalNav
                title="Interviews"
                titleClassName="text-muted-color font-medium text-sm"
                headerClassName="mb-0 py-1"
                className="w-full pt-0"
                items={interviews?.map(interview => ({
                    id: String(interview.id),
                    header: interview.id.startsWith('temp-') 
                        ? 'New Interview' 
                        : interview.interview.interviewee_name || 'N/A',
                    subheader: interview.interview.interviewee_type || '-',
                }))}
                selectedId={selectedInterviewId || ''}
                onSelectionChange={onSelectInterview}
                headerAction={
                    <ButtonV2
                        variant="ghost"
                        className="text-blue-600 hover:text-blue-700 p-1 hover:bg-blue-50 rounded transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                        title={hasTemporaryInterview ? "Save the new interview before adding another" : "Add Interview"}
                        onClick={onAddInterview}
                        prefix={<Plus className="w-4 h-4 text-[#3551F3]" />}
                        disabled={hasTemporaryInterview}
                    />
                }
            />
        </div>
    );
};

export default InterviewList;